import React from 'react';
import {
  Grid,
  Paper,
  Typography,
  Stack,
  Chip,
  Box,
  IconButton,
  Tooltip
} from '@mui/material';
import {
  Phone as PhoneIcon,
  Email as EmailIcon,
  Edit as EditIcon
} from '@mui/icons-material';
import { Contact } from '../../types';

interface ContactListProps {
  contacts: Contact[];
  onEdit: (contact: Contact) => void;
}

export const ContactList: React.FC<ContactListProps> = ({
  contacts,
  onEdit
}) => {
  return (
    <Grid container spacing={3}>
      {contacts.map((contact) => (
        <Grid item xs={12} sm={6} md={4} key={contact.id}>
          <Paper 
            sx={{ 
              p: 3, 
              position: 'relative',
              height: '100%',
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <Box sx={{ position: 'absolute', top: 16, right: 16 }}>
              <Tooltip title="Edit contact">
                <IconButton
                  size="small"
                  onClick={() => onEdit(contact)}
                  color="primary"
                >
                  <EditIcon />
                </IconButton>
              </Tooltip>
            </Box>

            <Box sx={{ mb: 2, pr: 4 }}>
              <Typography variant="subtitle1">
                {contact.firstName} {contact.lastName}
                {contact.isPrimary && (
                  <Chip
                    label="Primary"
                    size="small"
                    color="primary"
                    sx={{ ml: 1 }}
                  />
                )}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {contact.relationship.replace('_', ' ')}
              </Typography>
            </Box>

            <Stack spacing={1} sx={{ mt: 'auto' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <PhoneIcon fontSize="small" color="action" />
                <Typography variant="body2">
                  {contact.phone}
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <EmailIcon fontSize="small" color="action" />
                <Typography variant="body2">
                  {contact.email}
                </Typography>
              </Box>
            </Stack>
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
};